import { Action } from '@ngrx/store';
import { Order } from '../../types/order.types';

export enum OrdersActionTypes {
  Load = '[Orders] Load',
  LoadSuccess = '[Orders] Load Success',
  LoadFail = '[Orders] Load Fail'
}

export class LoadOrders implements Action {
  public readonly type = OrdersActionTypes.Load;

  constructor(public payload: { dealId: string; reload: boolean }) {}
}

export class LoadOrdersSuccess implements Action {
  public readonly type = OrdersActionTypes.LoadSuccess;

  constructor(public payload: Order[]) {}
}

export class LoadOrdersFail implements Action {
  public readonly type = OrdersActionTypes.LoadFail;

  constructor(public payload: string) {}
}
export type OrdersActionsUnion =
  | LoadOrders
  | LoadOrdersSuccess
  | LoadOrdersFail;
